import { styled } from '@mui/material/styles';
import {
  Box,
  Button,
  Card,
  CardHeader,
  CardContent,
  Grid,
  ImageList,
  ImageListItem,
  Stack,
  Typography,
  Alert,
} from '@mui/material';

export const MainContainer = styled('div')({
  display: 'block',
});

export const MainBox = styled(Box)({
  flexGrow: 1,
});

export const HeaderStack = styled(Stack)(({ theme }) => ({
  marginBottom: 16,
  [theme.breakpoints.down('sm')]: {
    marginBottom: 12,
    padding: '0 8px',
  },
}));

export const MainHeading = styled(Typography)(({ theme }) => ({
  fontSize: '2.5em',
  fontWeight: '400',
  lineHeight: 1.2,
  color: theme.palette.text.primary,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
    lineHeight: 1.3,
    textAlign: 'center',
  },
  [theme.breakpoints.down('xs')]: {
    fontSize: '1.3rem',
  },
}));

export const SubtitleText = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: '400',
  lineHeight: 1.5,
  color: theme.palette.text.secondary,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
    lineHeight: 1.4,
    textAlign: 'center',
  },
  [theme.breakpoints.down('xs')]: {
    fontSize: '0.85rem',
  },
}));

export const CarouselContainer = styled('span')(({ theme }) => ({
  display: 'block',
  marginBottom: 16,
  [theme.breakpoints.down('sm')]: {
    marginBottom: 12,
    padding: '0 4px',
  },
}));

export const MainGrid = styled(Grid)(({ theme }) => ({
  marginTop: 16,
  [theme.breakpoints.down('sm')]: {
    marginTop: 12,
    padding: '0 4px',
  },
  [theme.breakpoints.down('xs')]: {
    marginTop: 8,
    padding: '0 2px',
  },
}));

export const SidebarGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1),
  },
}));

export const MainCard = styled(Card)(({ theme }) => ({
  width: '100%',
  height: 'auto',
  marginBottom: 16,
  boxShadow: theme.shadows[1],
  [theme.breakpoints.down('sm')]: {
    marginBottom: 12,
    maxWidth: '100%',
    overflow: 'hidden',
  },
  [theme.breakpoints.down('xs')]: {
    marginBottom: 8,
  },
}));

export const CardHeaderStyled = styled(CardHeader)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: '4px 4px 0px 0px',
  margin: `-${theme.spacing(0.625)}`,
  boxShadow: theme.shadows[1],
  '& .MuiCardHeader-title': {
    color: theme.palette.primary.contrastText,
    fontSize: '1.5rem',
    fontWeight: '500',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
      lineHeight: 1.3,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
    },
  },
  '& .MuiCardHeader-subheader': {
    color: theme.palette.primary.contrastText,
    opacity: 0.9,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
      lineHeight: 1.2,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
    },
  },
  '& .MuiCardHeader-action': {
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}));

export const CardContentStyled = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
    maxWidth: '100%',
    overflow: 'hidden',
  },
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(1),
  },
}));

export const ViewAllButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
  },
}));

export const SpotifyIframe = styled('iframe')(({ theme }) => ({
  borderRadius: '12px',
  width: '100%',
  height: '352px',
  border: 'none',
  [theme.breakpoints.down('sm')]: {
    height: '280px',
  },
  [theme.breakpoints.down('xs')]: {
    height: '240px',
  },
}));

export const ReviewsImageList = styled(ImageList)(({ theme }) => ({
  margin: 0,
  padding: 0,
  [theme.breakpoints.down('sm')]: {
    gap: '4px !important',
  },
}));

export const ReviewImageListItem = styled(ImageListItem)({
  breakInside: 'avoid',
  marginBottom: 8,
});

export const ProfilePicture = styled('img')({
  maxWidth: '95%',
  margin: 'auto',
  display: 'block',
});

export const MainPageContainer = styled('div')({
  alignSelf: 'center',
  justifyContent: 'center',
  width: '100%',
});

export const CarouselItem = styled('div')({
  width: 'auto',
});

export const LoadingContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(2.5),
}));

export const ErrorAlert = styled(Alert)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
